/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';

import { Form } from '@organisms';

import VideoSelect from '../VideoSelect';

const VideoField = ({ onChange, allowClear = true, ...props }) => (
  <Form.Item {...props}>
    <VideoSelect onChange={onChange} allowClear={allowClear} />
  </Form.Item>
);

export default VideoField;
